import { render, staticRenderFns } from "./AlarmBoard.vue?vue&type=template&id=22663917"
import script from "./AlarmBoard.vue?vue&type=script&lang=js"
export * from "./AlarmBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports